
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.48 14.215l-5.4-9.001A2.5 2.5 0 0013.936 4H5.252a1.25 1.25 0 00-1.024 1.967l8.693 12.419a16.169 16.169 0 018.56-4.171zM42.748 4h-8.684a2.5 2.5 0 00-2.144 1.214l-5.4 9a16.173 16.173 0 018.559 4.171l8.693-12.418A1.25 1.25 0 0042.748 4zM24 16.5c-7.594 0-13.75 6.156-13.75 13.75S16.406 44 24 44s13.75-6.156 13.75-13.75S31.594 16.5 24 16.5zm7.228 12.286l-2.963 2.887.7 4.08a.897.897 0 01-1.3.945L24 34.772l-3.664 1.926a.896.896 0 01-1.3-.945l.7-4.08-2.963-2.887a.897.897 0 01.496-1.53l4.096-.597 1.83-3.713a.883.883 0 01.803-.5.89.89 0 01.807.5l1.83 3.713 4.097.596a.897.897 0 01.496 1.531z","fill":"#535353"}})])
          )
        }
      }
    